import { FC } from "react";
import { Link } from "react-router-dom";

import ArrowRightIcon from "web/assets/icons/arrow-right.svg";

import classes from "./list.scss";
import { CategoryListItemData } from "./utils/types";

interface ICategoryListItemProps {
  category: CategoryListItemData;
  onClick: () => void;
}

const CategoryListItem: FC<ICategoryListItemProps> = ({
  category,
  onClick,
}) => {
  const content = (
    <>
      <span>{category.name}</span>
      <ArrowRightIcon width={10} />
    </>
  );

  if (category.hasSubcategory) {
    return (
      <button type="button" className={classes.navItem} onClick={onClick}>
        {content}
      </button>
    );
  }

  return (
    <Link
      className={classes.navItem}
      to={category.redirectUrl}
      onClick={onClick}
    >
      {content}
    </Link>
  );
};

export default CategoryListItem;
